import { useContext, useMemo } from "react";
import { AuthContext } from "../contexts/AuthContext";

export const useRootFolderLabel = () => {
  const { dataScopeOrg } = useContext(AuthContext);

  const rootFolderLabel = useMemo(
    () => dataScopeOrg?.fullName || "Your Folders",
    [dataScopeOrg]
  );

  return rootFolderLabel;
};
